module.exports = __webpack_public_path__ + "2b406083a457432831cb50c658d31bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/inactive-icon-cosmetic@2x.png
// module id = 1759
// module chunks = 0